import { Brand } from "@/shared/types/Organization/brand";
import { Department } from "@/shared/types/Organization/department";
import { Position } from "@/shared/types/Organization/position";

export function getBrandName(brands: Brand[], brandId?: number | null) {
  return brands.find((b) => b.id === brandId)?.name || "";
}

export function getDepartmentName(departments: Department[], departmentId?: number | null) {
  return departments.find((d) => d.id === departmentId)?.name || "";
}

export function getPositionName(positions: Position[], positionId?: number | null) {
  return positions.find((p) => p.id === positionId)?.name || "";
}
